"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _react = _interopRequireDefault(require("react"));

var _CustomButton = _interopRequireDefault(require("../../assets/Theme9/CustomButton.css"));

var _Arrow = _interopRequireDefault(require("./Arrow2"));

var _utils = require("../utils");

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var cx = _bind["default"].bind(_CustomButton["default"]);

var Level1Item = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Level1Item, _React$PureComponent);

  function Level1Item() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Level1Item.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        item = _this$props.item,
        language = _this$props.language,
        isOpen = _this$props.isOpen,
        style = _this$props.style,
        onMouseOver = _this$props.onMouseOver,
        onMouseOut = _this$props.onMouseOut,
        onClick = _this$props.onClick;
    var title;

    if (item.type === 0) {
      title = (0, _utils.getLinkTitle)(item, language);
    } else {
      var temp = item.children[0];
      title = (0, _utils.getLinkTitle)(temp, language);
    }

    return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
      onMouseOut: onMouseOut,
      onMouseOver: onMouseOver,
      style: style,
      onClick: onClick,
      vertical: "center",
      className: cx("ButtonTheme9Level1")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: cx("ButtonTheme9title")
    }, title), item.type === 0 ? /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
      fill: style.color,
      position: isOpen ? "down" : "right",
      style: {
        marginLeft: 5
      }
    }) : null);
  };

  return Level1Item;
}(_react["default"].PureComponent);

var _default = Level1Item;
exports["default"] = _default;
module.exports = exports.default;